export const SET_SINGLE = 'setSingle'
export const SET_LIST = 'setList'
export const SET_LOADING = 'setLoading'
export const SET_TOGGLE = 'setToggle'
export const FETCH_END = 'setProjects'
export const FETCH_START = 'setLoading'
export const PURGE_AUTH = 'logOut'
export const SET_PROJECT = 'setProject'
export const SET_AUTH = 'setUser'
export const SET_ERROR = 'setError'
export const SET_TASK = 'setTask'
export const SET_TASKS = 'setTasks'
export const SET_TYPES = 'setTypes'
// export const SET_USERS = 'setUsers'
export const SET_METAS = 'setMetas'
export const SET_STATS = 'setStats'
export const RESET_STATE = 'resetState'
export const RESET_STATE_TASK = 'resetStateTask'
